import { createClient } from '@supabase/supabase-js';
import type { Database } from './database.types';
import { createSupabaseStorage } from './supabaseStorage';

const supabaseUrl: string | undefined = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey: string | undefined = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  console.warn(
    '[Arbi] Supabase credentials not set. ' +
      'Copy .env.example to .env.local and fill in your project URL and anon key.'
  );
}

// Day 62a (ADR 38) — custom storage adapter for cross-subdomain SSO. On
// *.ironcladsupply.co hosts the auth token writes to a cookie scoped to
// .ironcladsupply.co; on localhost / vercel preview URLs it falls back
// to localStorage. See src/lib/supabaseStorage.ts.
export const supabase = createClient<Database>(
  supabaseUrl ?? 'https://placeholder.supabase.co',
  supabaseAnonKey ?? 'placeholder',
  {
    auth: {
      storage: createSupabaseStorage(),
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
    },
  }
);

if (import.meta.env.DEV) (window as unknown as { supabase: typeof supabase }).supabase = supabase;
